// src/services/adminService.js
import { usersPermissionsAPI } from './api';

export const usersPermissionsService = {
  getUsers: async () => {
    try {
      const response = await usersPermissionsAPI.getUsers();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching users:', error);
      throw new Error(error.response?.data?.message || 'Failed to load users');
    }
  },

  getUserPermissions: async (userId) => {
    try {
      console.log(`🔍 Fetching permissions for user: ${userId}`);
      const response = await usersPermissionsAPI.getUserPermissions(userId);
      console.log('✅ User permissions loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching user permissions:', {
        userId,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url: error.config?.url
      });
      
      if (error.response?.status === 404) {
        throw new Error('Permissions endpoint not found. Please check the server configuration.');
      }
      
      throw new Error(error.response?.data?.message || 'Failed to load user permissions');
    }
  },

  getModules: async () => {
    try {
      const response = await usersPermissionsAPI.getModules();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching modules:', error);
      throw new Error(error.response?.data?.message || 'Failed to load modules');
    }
  },
  updatePermissions: async (permissionsData) => {
    try {
      const response = await usersPermissionsAPI.updatePermissions(permissionsData);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating permissions:', error);
      throw new Error(error.response?.data?.message || 'Failed to update permissions');
    }
  },

  toggleUserStatus: async (userId) => {
    try {
      const response = await usersPermissionsAPI.toggleUserStatus(userId);
      return response.data;
    } catch (error) {
      console.error('❌ Error toggling user status:', error);
      throw new Error(error.response?.data?.message || 'Failed to update user status');
    }
  }
};